import styled from '@emotion/styled'

export const ControlsContainer = styled.div({
    width: '100%',
    // maxWidth: '580px',
    height: '100%',
    position: 'relative',
    borderRadius: 'inherit',
    display: 'flex',
    justifyContent: 'center',
})
